import React, { useState, useEffect } from 'react';
import { Breadcrumb, Collapse, Switch } from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  DatePicker,
  ConfigProvider,
  BackTop,
  Select,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';
import TextEditor from 'modules/layoutModule/components/TextEditor/TextEditor';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import {
  getAdministrators,
  getExpertArticleById,
  saveExpertArticle,
} from '../requests/expertArticlesRequests';
import dayjs from 'dayjs';
import locale from 'antd/locale/pl_PL';
import 'dayjs/locale/pl';
import copyToClipboard from 'helpers/copyToClipboard';

const { TextArea } = Input;
const { Panel } = Collapse;

const ExpertArticlesEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [contentValue, setContentValue] = useState<string | undefined>('');
  const [fileImage1, setFileImage1] = useState<string | null>(null);
  const [fileImage2, setFileImage2] = useState<string | null>(null);
  const [fileImage3, setFileImage3] = useState<string | null>(null);
  const [fileImage4, setFileImage4] = useState<string | null>(null);
  const [fileImage5, setFileImage5] = useState<string | null>(null);
  const [fileImage6, setFileImage6] = useState<string | null>(null);
  const [fileImage7, setFileImage7] = useState<string | null>(null);
  const [fileImage8, setFileImage8] = useState<string | null>(null);
  const [fileImage9, setFileImage9] = useState<string | null>(null);
  const [fileImage10, setFileImage10] = useState<string | null>(null);
  const [fileImage1Changed, changedFileImage1] = useState<boolean>(false);
  const [fileImage2Changed, changedFileImage2] = useState<boolean>(false);
  const [fileImage3Changed, changedFileImage3] = useState<boolean>(false);
  const [fileImage4Changed, changedFileImage4] = useState<boolean>(false);
  const [fileImage5Changed, changedFileImage5] = useState<boolean>(false);
  const [fileImage6Changed, changedFileImage6] = useState<boolean>(false);
  const [fileImage7Changed, changedFileImage7] = useState<boolean>(false);
  const [fileImage8Changed, changedFileImage8] = useState<boolean>(false);
  const [fileImage9Changed, changedFileImage9] = useState<boolean>(false);
  const [fileImage10Changed, changedFileImage10] = useState<boolean>(false);
  const [representatives, setRepresentatives] = useState<any[]>([]);

  useEffect(() => {
    toggleLoading(true);

    getAdministrators().then((response) => {
      if (response) {
        const representatives = response.map(
          (representative: { name: string; id: number }) => {
            return {
              label: representative.name,
              value: representative.id,
            };
          }
        );
        setRepresentatives(representatives);
      }
    });

    getExpertArticleById(id)
      .then((response) => {
        if (response) {
          toggleLoading(false);
          const { data } = response;
          const { rows } = data;
          const { categories } = data;
          setFields([
            {
              name: ['id'],
              value: rows.id,
            },
            {
              name: ['title'],
              value: rows.name,
            },
            {
              name: ['youtubeURL1'],
              value: rows.youtubeURL1,
            },
            {
              name: ['youtubeURL2'],
              value: rows.youtubeURL2,
            },
            {
              name: ['youtubeURL3'],
              value: rows.youtubeURL3,
            },
            {
              name: ['dateAdd'],
              value: dayjs(rows.dateAdd, 'YYYY/MM/DD HH:mm:ss'),
            },
            {
              name: ['content'],
              value: rows.content,
            },
            {
              name: ['idCategory'],
              value: rows.idCategory,
            },
            {
              name: ['fileImage1'],
              value: rows.fileImage1,
            },
            {
              name: ['fileImage2'],
              value: rows.fileImage2,
            },
            {
              name: ['fileImage3'],
              value: rows.fileImage3,
            },
            {
              name: ['fileImage4'],
              value: rows.fileImage4,
            },
            {
              name: ['fileImage5'],
              value: rows.fileImage5,
            },
            {
              name: ['fileImage6'],
              value: rows.fileImage6,
            },
            {
              name: ['fileImage7'],
              value: rows.fileImage7,
            },
            {
              name: ['fileImage8'],
              value: rows.fileImage8,
            },
            {
              name: ['fileImage9'],
              value: rows.fileImage9,
            },
            {
              name: ['fileImage10'],
              value: rows.fileImage10,
            },
            {
              name: ['isActive'],
              value: rows.isActive,
            },
            {
              name: ['videoTime'],
              value: rows.videoTime,
            },
            {
              name: ['table1'],
              value: rows.table1,
            },
            {
              name: ['table2'],
              value: rows.table2,
            },
            {
              name: ['table3'],
              value: rows.table3,
            },
            {
              name: ['table4'],
              value: rows.table4,
            },
            {
              name: ['table5'],
              value: rows.table5,
            },
            {
              name: ['alt1'],
              value: rows.alt1,
            },
            {
              name: ['alt2'],
              value: rows.alt2,
            },
            {
              name: ['alt3'],
              value: rows.alt3,
            },
            {
              name: ['alt4'],
              value: rows.alt4,
            },
            {
              name: ['alt5'],
              value: rows.alt5,
            },
            {
              name: ['alt6'],
              value: rows.alt6,
            },
            {
              name: ['alt7'],
              value: rows.alt7,
            },
            {
              name: ['alt8'],
              value: rows.alt8,
            },
            {
              name: ['alt9'],
              value: rows.alt9,
            },
            {
              name: ['alt10'],
              value: rows.alt10,
            },
            {
              name: ['idAdministrator'],
              value: rows.idAdministrator,
            },
          ]);
          setContentValue(rows.content);
          form.setFieldsValue({
            fileImage1: rows?.fileImage1,
            fileImage2: rows?.fileImage2,
            fileImage3: rows?.fileImage3,
            fileImage4: rows?.fileImage4,
            fileImage5: rows?.fileImage5,
            fileImage6: rows?.fileImage6,
            fileImage7: rows?.fileImage7,
            fileImage8: rows?.fileImage8,
            fileImage9: rows?.fileImage9,
            fileImage10: rows?.fileImage10,
          });

          setFileImage1(rows?.fileImage1);
          setFileImage2(rows?.fileImage2);
          setFileImage3(rows?.fileImage3);
          setFileImage4(rows?.fileImage4);
          setFileImage5(rows?.fileImage5);
          setFileImage6(rows?.fileImage6);
          setFileImage7(rows?.fileImage7);
          setFileImage8(rows?.fileImage8);
          setFileImage9(rows?.fileImage9);
          setFileImage10(rows?.fileImage10);
          setCategories(categories);
        } else {
          history.push('/expert-articles');
        }
      })
      .catch(() => {
        history.push('/expert-articles');
      });
  }, []);

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    saveExpertArticle(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const onContentEdit = (e: any) => {
    setFields([
      {
        name: ['content'],
        value: e,
      },
    ]);
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void,
    imageChanged?: (value: boolean) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
    if (imageChanged) {
      imageChanged(true);
    }
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Wiedza</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/expert-articles">Porady ekspertów</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/expert-articles/${id}`}>Edycja wpisu</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="fileImage1"
                label="Okładka"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage1}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage1',
                      setFileImage1,
                      changedFileImage1
                    )
                  }
                  isNew={fileImage1Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage1"
                  number={1}
                />
              </Form.Item>
              <Form.Item name="alt1" label="Opis zdjęcia okładki">
                <Input />
              </Form.Item>
              <Form.Item name="fileImage2" label="Obrazek 2">
                <FormCoverUpload
                  cover={fileImage2}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage2',
                      setFileImage2,
                      changedFileImage2
                    )
                  }
                  isNew={fileImage2Changed}
                  field="fileImage2"
                  number={2}
                />
              </Form.Item>
              <Form.Item name="alt2" label="Opis zdjęcia 2">
                <Input />
              </Form.Item>
              <Form.Item name="fileImage3" label="Obrazek 3">
                <FormCoverUpload
                  cover={fileImage3}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage3',
                      setFileImage3,
                      changedFileImage3
                    )
                  }
                  isNew={fileImage3Changed}
                  field="fileImage3"
                  number={3}
                />
              </Form.Item>
              <Form.Item name="alt3" label="Opis zdjęcia 3">
                <Input />
              </Form.Item>
              <Form.Item name="fileImage4" label="Obrazek 4">
                <FormCoverUpload
                  cover={fileImage4}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage4',
                      setFileImage4,
                      changedFileImage4
                    )
                  }
                  isNew={fileImage4Changed}
                  field="fileImage4"
                  number={4}
                />
              </Form.Item>
              <Form.Item name="alt4" label="Opis zdjęcia 4">
                <Input />
              </Form.Item>
              <Form.Item name="fileImage5" label="Obrazek 5">
                <FormCoverUpload
                  cover={fileImage5}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage5',
                      setFileImage5,
                      changedFileImage5
                    )
                  }
                  isNew={fileImage5Changed}
                  field="fileImage5"
                  number={5}
                />
              </Form.Item>
              <Form.Item name="alt5" label="Opis zdjęcia 5">
                <Input />
              </Form.Item>
              <Form.Item name="fileImage6" label="Obrazek 6">
                <FormCoverUpload
                  cover={fileImage6}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage6',
                      setFileImage6,
                      changedFileImage6
                    )
                  }
                  isNew={fileImage6Changed}
                  field="fileImage6"
                  number={6}
                />
              </Form.Item>
              <Form.Item name="alt6" label="Opis zdjęcia 6">
                <Input />
              </Form.Item>
              <Form.Item name="fileImage7" label="Obrazek 7">
                <FormCoverUpload
                  cover={fileImage7}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage7',
                      setFileImage7,
                      changedFileImage7
                    )
                  }
                  isNew={fileImage7Changed}
                  field="fileImage7"
                  number={7}
                />
              </Form.Item>
              <Form.Item name="alt7" label="Opis zdjęcia 7">
                <Input />
              </Form.Item>
              <Form.Item name="fileImage8" label="Obrazek 8">
                <FormCoverUpload
                  cover={fileImage8}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage8',
                      setFileImage8,
                      changedFileImage8
                    )
                  }
                  isNew={fileImage8Changed}
                  field="fileImage8"
                  number={8}
                />
              </Form.Item>
              <Form.Item name="alt8" label="Opis zdjęcia 8">
                <Input />
              </Form.Item>
              <Form.Item name="fileImage9" label="Obrazek 9">
                <FormCoverUpload
                  cover={fileImage9}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage9',
                      setFileImage9,
                      changedFileImage9
                    )
                  }
                  isNew={fileImage9Changed}
                  field="fileImage9"
                  number={9}
                />
              </Form.Item>
              <Form.Item name="alt9" label="Opis zdjęcia 9">
                <Input />
              </Form.Item>
              <Form.Item name="fileImage10" label="Obrazek 10">
                <FormCoverUpload
                  cover={fileImage10}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage10',
                      setFileImage10,
                      changedFileImage10
                    )
                  }
                  isNew={fileImage10Changed}
                  field="fileImage10"
                  number={10}
                />
              </Form.Item>
              <Form.Item name="alt10" label="Opis zdjęcia 10">
                <Input />
              </Form.Item>
              <ConfigProvider locale={locale}>
                <Form.Item
                  name="dateAdd"
                  label="Data dodania"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  {/*// @ts-ignore*/}
                  <DatePicker showTime />
                </Form.Item>
              </ConfigProvider>
              <Form.Item
                name="idAdministrator"
                label="Autor"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Wybierz autora"
                  optionFilterProp="children"
                  options={representatives}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item
                name="idCategory"
                label="Kategoria"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Wybierz kategorię"
                  optionFilterProp="children"
                  options={categories}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      const label = option?.label as string;
                      return label.toLowerCase().includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item
                name="title"
                label="Tytuł"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="content"
                label="Treść"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <TextEditor
                  initialValue={contentValue}
                  onChange={onContentEdit}
                  disableGallery
                />
              </Form.Item>
              <Form.Item name="youtubeURL1" label="Link do youtube nr. 1">
                <Input />
              </Form.Item>
              <Form.Item name="youtubeURL2" label="Link do youtube nr. 2">
                <Input />
              </Form.Item>
              <Form.Item name="youtubeURL3" label="Link do youtube nr. 3">
                <Input />
              </Form.Item>
              <div className="tables-collapse">
                <Collapse defaultActiveKey={[]}>
                  <Panel header="Tabelka 1" key="1" forceRender>
                    <Form.Item name="table1" label="Tabelka 1">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#1')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#1
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 2" key="2" forceRender>
                    <Form.Item name="table2" label="Tabelka 2">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#2')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#2
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 3" key="3" forceRender>
                    <Form.Item name="table3" label="Tabelka 3">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#3')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#3
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 4" key="4" forceRender>
                    <Form.Item name="table4" label="Tabelka 4">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#4')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#4
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 5" key="5" forceRender>
                    <Form.Item name="table5" label="Tabelka 5">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#5')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#5
                    </Button>
                  </Panel>
                </Collapse>
              </div>
              <Form.Item
                name="isActive"
                label="Aktywność"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/expert-articles">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/expert-articles">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default ExpertArticlesEdit;
